
















import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'

@Component({
  components: {
    CallTeamPatient: () => import('@/components/call/CallTeamPatient.vue'),
    Loading: () => import('@/components/common/loadings/Index.vue')
  }
})
export default class CallTeamList extends Vue {
  $store!: ExStore
  isLoading = true

  async beforeCreate() {
    this.$store.dispatch('team/updatePatients').then(() => {
      this.isLoading = false
    })
  }

  get patients() {
    return this.$store.state.team.patients
  }

  get partners() {
    return this.$store.getters['call/callPartners'].map(p => p.id)
  }
}
